export const Mbrship_Plans = {
    DOMII_BASIC_FREE: "g6mg",
    DOMII_PRO_WO_TEAM_BUILD: "33rg",
    DOMII_PRO_W_TEAM_BUILD: "87fb",
    DOMII_ADVANTAGE: "p5sm",
    PROF_SIGNUP: "2886"
}